import { render, staticRenderFns } from "./HeaderHero.vue?vue&type=template&id=16b8aa28&scoped=true&"
import script from "./HeaderHero.vue?vue&type=script&lang=js&"
export * from "./HeaderHero.vue?vue&type=script&lang=js&"
import style0 from "./HeaderHero.vue?vue&type=style&index=0&id=16b8aa28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b8aa28",
  null
  
)

export default component.exports